import { getEffectiveUserStatus } from '@modules/user/utils/getEffectiveUserStatus';
import { styled } from '@mui/material';
import type { IWorkspaceUser } from 'src/@types/workspace-info';
import BadgeStatus from 'src/components/badge-status';
import { CustomAvatar } from 'src/components/custom-avatar';

const P2PAvatarContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

const BadgeContainer = styled('div')(() => ({
  borderRadius: '50%',
}));

type Props = {
  otherUser: IWorkspaceUser;
};

export const P2PChannelAvatar = ({ otherUser }: Props) => {
  return (
    <P2PAvatarContainer>
      <CustomAvatar
        alt={otherUser?.name}
        src={otherUser?.picture || ''}
        name={otherUser?.name}
        sx={{ width: 24, height: 24, fontSize: '0.75rem' }}
      />
      <BadgeContainer>
        <BadgeStatus status={getEffectiveUserStatus(otherUser)} />
      </BadgeContainer>
    </P2PAvatarContainer>
  );
};
